export default function initPersonLogoUpload() {
	$('.logo-form').off('submit');
	$('.logo-form').on('submit', function (e) {
		e.preventDefault();

		const $this = $(this);
		const fileData = $this.find('input.logo-file').prop('files')[0];
		const formData = new FormData();
		formData.append('logos', fileData);
		formData.append('person', $this.find('input[name="person"]').val() as string);

		$.ajax({
			url: $this.attr('action'),
			type: 'POST',
			dataType: 'text',
			cache: false,
			contentType: false,
			processData: false,
			data: formData,
			success: function () {
				window.location.reload();
			}
		})
	});

	$('input.logo-file').off('change');
	$('input.logo-file').change(function () {
		$(this).parent().submit();
	});

	$('.person-logo--editable').off('click');
	$('.person-logo--editable').click(function () {
		$(this).parent().find('input.logo-file').click();
		return false;
	});
};
